import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

/**
 * Protected route wrapper for user-only pages (like checkout)
 * Redirects to sign-in with return URL if not authenticated
 */
function UserProtectedRoute({ children }) {
    const { isAuthenticated, isAdmin } = useContext(AuthContext);
    const location = useLocation();

    if (!isAuthenticated || isAdmin) {
        // Redirect to sign-in with the current URL as redirect parameter
        const redirectUrl = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/sign-in?redirect=${redirectUrl}`} replace />;
    }

    return children;
}

export default UserProtectedRoute;
